/* Sale mode for the BENCH weekend — display only.
   When the visitor carries the sale codes (cookie / localStorage set by the
   landing), the product page and the cart page SHOW what checkout will
   charge: main products −30% (accessories keep their price), the Preview
   add-on FREE, and a "free shipping · free rush" note. Nothing here changes a
   price — Shopify applies the codes at checkout (cart-page hand-off).

   Bounds: on only with ≥2 sale codes present AND inside the sale window
   (visitor local time) — a BENCHTEST* code list bypasses the window so the
   flow can be checked ahead of Aug 21. Off = the page is untouched. */
(function () {
  'use strict';
  if (window.__benchMode) return; window.__benchMode = true; // rendered on product + cart, once per page
  var PCT = 0.30;
  // both $19.95 preview add-ons (dolls / pets) — same list the BENCHPREVIEW code carries
  var PREVIEW_VARIANTS = { '46507568431384': 1, '48771104899352': 1 };
  var isPreview = function (vid, sku) { return !!PREVIEW_VARIANTS[String(vid)] || String(sku || '').toUpperCase() === 'PREVIEW'; };
  var OPEN = new Date('2026-08-21T09:00:00'), CLOSE = new Date('2026-08-23T23:59:59');

  function codes() {
    var m = document.cookie.match(/(?:^|; )discount_code=([^;]+)/);
    var list = m ? decodeURIComponent(m[1]).split(',').map(function (s) { return s.trim().toUpperCase(); }).filter(Boolean) : [];
    if (list.length < 2) { try { var ls = localStorage.getItem('bench_codes'); if (ls) list = JSON.parse(ls).map(function (s) { return String(s).toUpperCase(); }); } catch (e) {} }
    return list.length >= 2 && list.some(function (c) { return /^BENCH/.test(c); }) ? list : null;
  }
  var list = codes(); if (!list) return;
  var isTest = list.some(function (c) { return /^BENCHTEST/.test(c); });
  var now = Date.now();
  if (!isTest && (now < OPEN || now > CLOSE)) return;

  document.documentElement.setAttribute('data-bench-sale', '1');
  // money: learn the store's live format from a Liquid-rendered example
  // ("1.234,56 ₫" vs "$1,234.56") so decimals/thousands/symbol match the page
  var me = document.currentScript || document.querySelector('script[data-money-example]');
  var example = me ? me.getAttribute('data-money-example') : '$1,234.56'; // rendered from 123456 cents
  var noDecimals = !/\d[.,]\d\d\D*$/.test(example);
  var thousands = (example.match(/\d(\D)\d{3}/) || [])[1] || ',';
  var decimalSep = noDecimals ? '' : (example.match(/\d(\D)\d\d\D*$/) || [])[1];
  var prefix = (example.match(/^\D*/) || [''])[0], suffix = (example.match(/\D*$/) || [''])[0];
  function money(cents) {
    var v = cents / 100;
    var whole = Math.floor(noDecimals ? Math.round(v) : v);
    var frac = noDecimals ? '' : decimalSep + (Math.round((v - whole) * 100) + 100).toString().slice(1);
    return prefix + String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + frac + suffix;
  }
  var offPct = Math.round(PCT * 100);

  /* ---------- product page (personalizer) ---------- */
  function personalizer() {
    var root = document.querySelector('[data-personalizer]'); if (!root) return;
    // Preview row → FREE (display), preselected already
    root.querySelectorAll('.personalizer__upsell-input[data-variant-id]').forEach(function (input) {
      if (!isPreview(input.getAttribute('data-variant-id'))) return;
      var row = input.closest('.personalizer__up'); if (!row || row.querySelector('.bench-free')) return;
      var price = row.querySelector('.personalizer__up-price');
      if (price) { price.innerHTML = '<s>' + price.textContent.trim() + '</s> <b class="bench-free">FREE</b>'; }
      row.classList.add('personalizer__up--bench');
      if (!input.checked) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
    });
    // sticky bar: show sale total (main −30%, preview free) beside the struck full total
    var bar = root.querySelector('.personalizer__bar-total'); if (!bar || bar.querySelector('.bench-bar')) return;
    var totalEl = bar.querySelector('[data-personalizer-running-total]');
    var cmpEl = bar.querySelector('[data-personalizer-running-compare]');
    var wrap = document.createElement('span'); wrap.className = 'bench-bar'; bar.appendChild(wrap);
    // the note sits ABOVE the pill, never inside it — the bar is a horizontal
    // flex row (back · total · next) and any extra child breaks its layout
    var pill = bar.closest('.personalizer__bar') || bar.parentNode;
    var note = document.createElement('div'); note.className = 'bench-bar-note';
    note.textContent = 'This weekend: −' + offPct + '% · free preview · free rush · free shipping — applied at checkout';
    pill.parentNode.insertBefore(note, pill);
    function upsellCents() {
      var t = 0, prev = 0;
      root.querySelectorAll('.personalizer__upsell-input:checked').forEach(function (i) {
        var c = parseInt(i.getAttribute('data-price'), 10) || 0;
        if (isPreview(i.getAttribute('data-variant-id'))) prev += c; else t += c;
      });
      return { other: t, preview: prev };
    }
    function paint() {
      if (!window.PersonalizerCart || !window.PersonalizerCart.totalCents) return;
      var ctx = window.__personalizerCtx; if (!ctx) return;
      var full = window.PersonalizerCart.totalCents(ctx);
      var u = upsellCents();
      var main = Math.max(0, full - u.other - u.preview);
      var sale = Math.round(main * (1 - PCT)) + u.other; // preview → 0
      if (totalEl) { totalEl.setAttribute('data-bench-full', '1'); }
      wrap.innerHTML = '<b>' + money(sale) + '</b> <s>' + money(full) + '</s> <em>−' + offPct + '%</em>';
      if (cmpEl) cmpEl.hidden = true;
      if (totalEl) totalEl.hidden = true;
    }
    paint();
    new MutationObserver(paint).observe(totalEl || bar, { childList: true, characterData: true, subtree: true });
    root.addEventListener('change', function () { setTimeout(paint, 0); });
  }

  /* ---------- classic product page (Boost main-product, no personalizer) ----------
     Price block: struck full price + −30% price. Add-on rows come from the
     Qikify BoosterKit app (rendered by its own JS) — watch its container and
     mark the Preview row FREE whenever it (re)renders. Accessories keep price. */
  function classicProduct() {
    if (document.querySelector('[data-personalizer]')) return;
    var wrap = document.querySelector('.product-detail__price[data-price-wrapper]'); if (!wrap) return;
    var isAccessory = (document.body.className + ' ' + (document.querySelector('meta[property="product:category"]') || {}).content).toLowerCase().indexOf('accessories') !== -1;
    // product type isn't in the DOM reliably — the theme prints it in the JSON blob
    try { var pj = document.querySelector('[data-product-json]'); if (pj) { var p = JSON.parse(pj.textContent); isAccessory = /accessor/i.test(p.type || ''); } } catch (e) {}
    if (isAccessory) return;
    function paintPrice() {
      var el = wrap.querySelector('[data-product-price]'); if (!el || el.getAttribute('data-bench-done')) return;
      var txt = el.textContent.trim(); var num = parseFloat(txt.replace(/[^\d.,]/g, '').replace(/[.,](?=\d{3}\b)/g, '').replace(',', '.')); if (!num) return;
      var cents = Math.round(num * 100), sale = Math.round(cents * (1 - PCT));
      var box = document.createElement('div'); box.className = 'bench-price';
      box.innerHTML = '<b>' + money(sale) + '</b> <s>' + txt + '</s> <em>−' + offPct + '%</em><small>This weekend · free preview · free rush · free shipping — applied at checkout</small>';
      el.setAttribute('data-bench-done', '1'); el.style.display = 'none';
      wrap.appendChild(box);
      new MutationObserver(function () { // variant switch rewrites the price → repaint
        if (el.getAttribute('data-bench-done') === '1' && el.textContent.trim() !== txt) { el.removeAttribute('data-bench-done'); box.remove(); paintPrice(); }
      }).observe(el, { childList: true, characterData: true, subtree: true });
    }
    paintPrice();
    // Qikify BoosterKit rows (this store's build prefixes classes "qbk-", older
    // builds "bk-"): .qbk-offer > .qbk-offer__title / .qbk-offer__price--offer
    function paintApp() {
      document.querySelectorAll('.qbk-offer, .bk-offer').forEach(function (row) {
        if (row.querySelector('.bench-free')) return;
        var t = row.querySelector('.qbk-offer__title, .bk-offer__title'); if (!t || !/Preview\s*&\s*Unlimited\s*Edit/i.test(t.textContent)) return;
        var p = row.querySelector('.qbk-offer__price--offer, .qbk-offer__price, .bk-offer__price'); if (!p) return;
        p.innerHTML = '<s>' + p.textContent.trim() + '</s> <b class="bench-free">FREE</b>';
      });
    }
    paintApp();
    new MutationObserver(paintApp).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- cart page ---------- */
  function cartPage() {
    var items = document.querySelectorAll('.pzc__item[data-line-price]'); if (!items.length) return;
    var fullTotal = 0, saleTotal = 0;
    items.forEach(function (it) {
      var cents = parseInt(it.getAttribute('data-line-price'), 10) || 0;
      var type = (it.getAttribute('data-type') || '').toLowerCase();
      var vid = it.getAttribute('data-variant-id') || '';
      var priceEl = it.querySelector('.pzc__lineprice'); if (!priceEl) return;
      var sale;
      if (isPreview(vid, it.getAttribute('data-sku'))) { sale = 0; priceEl.innerHTML = '<s>' + money(cents) + '</s> <b class="bench-free">FREE</b>'; }
      else if (type === 'accessories') { sale = cents; }
      else { sale = Math.round(cents * (1 - PCT)); priceEl.innerHTML = '<s>' + money(cents) + '</s> <b>' + money(sale) + '</b> <em class="bench-chip">−' + offPct + '%</em>'; }
      fullTotal += cents; saleTotal += sale;
    });
    var totals = document.querySelectorAll('[data-pzc-total]');
    totals.forEach(function (t) { t.innerHTML = '<b>' + money(saleTotal) + '</b> <s>' + money(fullTotal) + '</s>'; });
    var summary = document.querySelector('.pzc__summary .pzc__row--total');
    if (summary && !summary.previousElementSibling.classList.contains('bench-row')) {
      var row = document.createElement('div'); row.className = 'pzc__row pzc__row--save bench-row';
      row.innerHTML = '<span>Bench weekend (applied at checkout)</span><span>−' + money(fullTotal - saleTotal) + '</span>';
      summary.parentNode.insertBefore(row, summary);
      var ship = document.querySelector('.pzc__summary .pzc__row--muted span:last-child'); if (ship) ship.textContent = 'free · rush included';
    }
  }

  function run() { personalizer(); classicProduct(); cartPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  // personalizer boots async — retry briefly until its ctx exists
  var tries = 0, iv = setInterval(function () { if (window.__personalizerCtx || ++tries > 40) { clearInterval(iv); personalizer(); } }, 250);
})();
